module.exports = __webpack_public_path__ + "Roboto-Thin.7500519de3d82e33d158.woff";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Thin.woff
// module id = 470
// module chunks = 2